<template>
  <div class="website-dashboard">
    <el-row :gutter="20">
      <el-col :span="8">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>新闻资讯</span>
          </div>
          <div class="card-body">
            <div class="stat-value">{{ newsCount }}</div>
            <div class="stat-label">已发布</div>
          </div>
          <el-button type="text" @click="goToNews">管理新闻资讯</el-button>
        </el-card>
      </el-col>
      
      <el-col :span="8">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>版本管理</span>
          </div>
          <div class="card-body">
            <div class="stat-value">{{ versionsCount }}</div>
            <div class="stat-label">总数</div>
          </div>
          <el-button type="text" @click="goToVersions">管理版本</el-button>
        </el-card>
      </el-col>
      
      <el-col :span="8">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>当前版本</span>
          </div>
          <div class="card-body" v-if="currentVersion">
            <div class="version-info">
              <div class="version-number">{{ currentVersion.version }}</div>
              <div class="version-title">{{ currentVersion.title }}</div>
              <div class="version-desc" v-if="currentVersion.description">{{ currentVersion.description }}</div>
            </div>
          </div>
          <div class="card-body" v-else>
            <div class="no-data">暂无版本信息</div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    
    <el-row :gutter="20" style="margin-top: 20px;">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>最新新闻</span>
          </div>
          <div v-if="latestNews.length > 0">
            <el-table :data="latestNews" style="width: 100%">
              <el-table-column prop="title" label="标题" min-width="200"></el-table-column>
              <el-table-column prop="subtitle" label="副标题" min-width="250"></el-table-column>
              <el-table-column prop="link" label="链接" width="120">
                <template slot-scope="scope">
                  <el-link v-if="scope.row.link" :href="scope.row.link" target="_blank" type="primary">
                    查看
                  </el-link>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="created_at" label="发布时间" width="180">
                <template slot-scope="scope">
                  {{ formatDate(scope.row.created_at) }}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-button size="mini" @click="editNews(scope.row)">编辑</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-else class="no-data">
            暂无新闻数据
          </div>
        </el-card>
      </el-col>
    </el-row>
    
    <el-row :gutter="20" style="margin-top: 20px;">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>最近版本</span>
          </div>
          <div v-if="latestVersions.length > 0">
            <el-table :data="latestVersions" style="width: 100%">
              <el-table-column prop="version" label="版本号" width="120"></el-table-column>
              <el-table-column prop="title" label="标题" min-width="200"></el-table-column>
              <el-table-column prop="description" label="描述" min-width="300"></el-table-column>
              <el-table-column prop="created_at" label="创建时间" width="180">
                <template slot-scope="scope">
                  {{ formatDate(scope.row.created_at) }}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-button size="mini" @click="editVersion(scope.row)">编辑</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-else class="no-data">
            暂无版本数据
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import request from '@/utils/request';

export default {
  name: 'WebsiteDashboard',
  data() {
    return {
      newsCount: 0,
      versionsCount: 0,
      currentVersion: null,
      latestNews: [],
      latestVersions: []
    };
  },
  created() {
    this.fetchDashboardData();
  },
  methods: {
    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
    },
    
    // 获取仪表板数据
    async fetchDashboardData() {
      try {
        // 获取最新3条新闻
        const latestNewsResponse = await request.get('/api/public/news/latest');
        this.latestNews = latestNewsResponse.data;
        
        // 获取新闻总数
        const newsResponse = await request.get('/api/public/news/count');
        this.newsCount = newsResponse.data.total;
        
        // 获取版本统计信息
        const versionsStatsResponse = await request.get('/api/admin/versions/stats');
        this.versionsCount = versionsStatsResponse.data.total;
        this.currentVersion = versionsStatsResponse.data.latestVersion;
        this.latestVersions = versionsStatsResponse.data.latestVersion ? [versionsStatsResponse.data.latestVersion] : [];
      } catch (error) {
        console.error('获取仪表板数据失败:', error);
        this.$message.error('获取仪表板数据失败');
      }
    },
    
    // 跳转到新闻管理
    goToNews() {
      this.$router.push('/adminyuanhui66/news');
    },
    
    // 跳转到版本管理
    goToVersions() {
      this.$router.push('/adminyuanhui66/versions');
    },
    
    // 编辑新闻
    editNews() {
      this.$router.push('/adminyuanhui66/news');
      // 这里可以通过Vuex或其他方式传递要编辑的新闻ID
    },
    
    // 编辑版本
    editVersion() {
      this.$router.push('/adminyuanhui66/versions');
      // 这里可以通过Vuex或其他方式传递要编辑的版本ID
    }
  }
};
</script>

<style scoped>
.website-dashboard {
  padding: 20px;
}

.box-card {
  margin-bottom: 20px;
}

.card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
}

.stat-value {
  font-size: 36px;
  font-weight: bold;
  color: #409EFF;
}

.stat-label {
  margin-top: 10px;
  color: #606266;
}

.version-info {
  text-align: center;
}

.version-number {
  font-size: 24px;
  font-weight: bold;
  color: #409EFF;
}

.version-title {
  margin-top: 10px;
  color: #606266;
}

.version-desc {
  margin-top: 8px;
  color: #909399;
  font-size: 12px;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.no-data {
  text-align: center;
  color: #909399;
  padding: 20px;
}
</style>